(() => {
  const attached = new WeakSet();
  const mount = frame => {
    let doc;
    try { doc = frame.contentDocument; } catch { return; }
    if (!doc?.body || attached.has(doc)) return;
    attached.add(doc);
    let contact = { name: '', email: '' };
    let pending = false;
    let submitted = false;
    let timer;
    const style = doc.createElement('style');
    style.textContent = '.eoj-details{display:flex;flex-direction:column}.eoj-details .answer-text{box-sizing:border-box;width:100%;min-height:44px}.eoj-details label{display:block}.eoj-contact-field{display:contents}.eoj-details .question-text{margin-top:14px}.eoj-details-note{font-size:14px;margin:0 0 8px}.eoj-details-error{color:#a52020;font-size:14px;margin:8px 0}.eoj-processing .modal-container>div:not(.eoj-processing-message),.eoj-processing .main-heading{display:none!important}.eoj-processing-message{padding:28px 0}';
    doc.head.append(style);
    const field = (container, key, label, type, order) => {
      const wrap = doc.createElement('div');
      wrap.className = 'eoj-contact-field';
      const caption = doc.createElement('label');
      caption.className = 'question-text';
      caption.htmlFor = `eoj-booking-${key}`;
      caption.textContent = `${label} *`;
      caption.style.order = order;
      const input = doc.createElement('input');
      input.id = caption.htmlFor;
      input.className = 'answer-text';
      input.type = type;
      input.required = true;
      input.autocomplete = key;
      input.value = contact[key];
      input.style.order = order + 1;
      input.addEventListener('input', () => { contact[key] = input.value; });
      wrap.append(caption, input);
      container.append(wrap);
      return input;
    };
    const process = () => {
      const questions = doc.querySelector('.custom-questions-container');
      if (questions && !questions.classList.contains('eoj-details')) {
        questions.classList.add('eoj-details');
        const pairs = [...questions.querySelectorAll('.question-text')].map(label => ({ label, input: label.nextElementSibling }));
        const age = pairs.find(p => /leeftijd/i.test(p.label.textContent));
        const phone = pairs.find(p => /telefoon/i.test(p.label.textContent));
        const extra = pairs.find(p => /extra informatie|schrijf een bericht/i.test(p.label.textContent));
        if (!age?.input || !phone?.input) return;
        for (const [pair, label, order, type] of [[age, 'Leeftijd van het kind', 2, 'text'], [phone, 'Telefoonnummer', 4, 'tel'], [extra, 'Extra informatie (optioneel)', 8, null]]) {
          if (!pair) continue;
          pair.label.style.order = order;
          pair.input.style.order = order + 1;
          const id = `eoj-booking-${order}`;
          pair.input.id = id;
          pair.label.id = `${id}-label`;
          pair.input.setAttribute('aria-labelledby', pair.label.id);
          pair.label.querySelector('.question-elements').textContent = label + (type ? ' *' : '');
          if (type) {
            pair.input.required = true;
            pair.input.type = type;
          }
        }
        age.input.inputMode = 'numeric';
        phone.input.autocomplete = 'tel';
        const nameInput = field(questions, 'name', 'Naam', 'text', 0);
        const emailInput = field(questions, 'email', 'E-mailadres', 'email', 6);
        [nameInput.parentElement, age.label, age.input, phone.label, phone.input, emailInput.parentElement, extra?.label, extra?.input].filter(Boolean).forEach(node => questions.append(node));
        const heading = doc.querySelector('.main-heading');
        if (heading) heading.textContent = 'Jouw gegevens';
        const note = doc.createElement('p');
        note.className = 'eoj-details-note';
        note.textContent = 'Vul je gegevens hieronder in. Velden met * zijn verplicht.';
        questions.before(note);
      }
      const button = doc.querySelector('.btn-book-questions');
      if (button) {
        const node = [...button.childNodes].find(n => n.nodeType === 3 && n.textContent.trim());
        if (node && node.textContent.trim() !== 'Afspraak bevestigen') node.textContent = 'Afspraak bevestigen';
      }
      const native = doc.querySelector('.btn-book-customer-details-questions');
      if (pending && native && !submitted) {
        const inputs = [...native.parentElement.parentElement.querySelectorAll('input')];
        if (inputs.length < 2) { pending = false; return; }
        submitted = true;
        const values = [contact.name.trim(), contact.email.trim(), phoneValue];
        inputs.forEach((input, i) => {
          if (values[i] === undefined) return;
          input.value = values[i];
          input.dispatchEvent(new doc.defaultView.Event('input', { bubbles: true }));
          input.dispatchEvent(new doc.defaultView.Event('change', { bubbles: true }));
        });
        queueMicrotask(() => {
          pending = false;
          if (!native.isConnected || native.disabled) {
            doc.body.classList.remove('eoj-processing');
            return;
          }
          native.click();
        });
      }
      if (submitted && !native) {
        clearTimeout(timer);
        doc.body.classList.remove('eoj-processing');
        doc.querySelector('.eoj-processing-message')?.remove();
      }
    };
    let phoneValue = '';
    doc.addEventListener('click', event => {
      if (event.target.closest('.action-close,.btn-back-button')) {
        pending = false;
        submitted = false;
        clearTimeout(timer);
        doc.body.classList.remove('eoj-processing');
        doc.querySelector('.eoj-processing-message')?.remove();
        if (event.target.closest('.action-close')) contact = { name: '', email: '' };
      }
      if (!event.target.closest('.btn-book-questions')) return;
      const container = doc.querySelector('.eoj-details');
      if (!container) return;
      for (const input of container.querySelectorAll('input[required]')) {
        if (!input.value.trim() || !input.checkValidity()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          input.reportValidity();
          input.focus();
          return;
        }
      }
      phoneValue = container.querySelector('input[type="tel"]').value;
      pending = true;
      submitted = false;
      doc.body.classList.add('eoj-processing');
      const message = doc.createElement('p');
      message.className = 'eoj-processing-message';
      message.setAttribute('role', 'status');
      message.textContent = 'Je afspraak wordt verwerkt…';
      doc.querySelector('.modal-container').append(message);
      timer = setTimeout(() => {
        pending = false;
        doc.body.classList.remove('eoj-processing');
        message.remove();
      }, 10000);
    }, true);
    const observer = new MutationObserver(process);
    observer.observe(doc.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled'] });
    process();
  };
  const discover = () => document.querySelectorAll('iframe#apntly-booking-iframe').forEach(frame => {
    mount(frame);
    if (!frame.dataset.eojDetailsListener) {
      frame.dataset.eojDetailsListener = 'true';
      frame.addEventListener('load', () => mount(frame));
    }
  });
  new MutationObserver(discover).observe(document.documentElement, { childList: true, subtree: true });
  discover();
})();

